import React, { useEffect, useState, useCallback, useRef } from 'react'
import { MapContainer, TileLayer, Marker, Tooltip, useMap } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import useApi from '../../Api'
import '../../styles/components/blog_page/WorldMapSection.css'
import BlogSection from './BlogSection'

delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

const SetInitialView = ({ coords }) => {
  const map = useMap()
  useEffect(() => {
    if (coords) {
      map.setView(coords, 5)
    }
  }, [coords, map])
  return null
}

const WorldMapSection = ({ origin_id = null, initialLatLng = null }) => {
  const [origins, setOrigins] = useState([])
  const [selectedOrigin, setSelectedOrigin] = useState(null)
  const apiClient = useApi()
  const hasFetched = useRef(false)

  const fetchOrigins = useCallback(() => {
    apiClient
      .get('/blog-origins')
      .then(response => setOrigins(response.data))
      .catch(console.error)
  }, [apiClient])

  useEffect(() => {
    if (!hasFetched.current) {
      fetchOrigins()
      hasFetched.current = true
    }
  }, [fetchOrigins])

  useEffect(() => {
    if (origin_id && origins.length > 0) {
      const matchedOrigin = origins.find(o => String(o.origin_id) === String(origin_id))
      if (matchedOrigin) {
        setSelectedOrigin(matchedOrigin)
      }
    }
  }, [origin_id, origins])

  return (
    <section className="world-map-section">
      <MapContainer center={initialLatLng || [54, 15]} zoom={initialLatLng ? 5 : 4} className="world-map">
        {initialLatLng && <SetInitialView coords={initialLatLng} />}
        <TileLayer attribution="&copy; OpenStreetMap contributors" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {origins.map(origin => {
          const num = origin.number_of_blogs
          let size = 30
          let fontSize = '16px'
          if (num < 10) {
            size = 30
            fontSize = '16px'
          } else if (num < 100) {
            size = 40
            fontSize = '14px'
          } else {
            size = 50
            fontSize = '12px'
          }
          const customIcon = new L.DivIcon({
            html: `<div class="custom-marker" style="width:${size}px;height:${size}px;line-height:${size}px;font-size:${fontSize}">${num}</div>`,
            className: '',
            iconSize: [size, size],
            iconAnchor: [size / 2, size / 2]
          })
          return (
            <Marker
              key={origin.origin_id}
              position={[origin.latitude, origin.longitude]}
              icon={customIcon}
              eventHandlers={{
                click: () => setSelectedOrigin(origin)
              }}
            >
              <Tooltip>{origin.origin_name}</Tooltip>
            </Marker>
          )
        })}
      </MapContainer>
      {selectedOrigin && (
        <div className="selected-origin-blog">
          <h2>{selectedOrigin.origin_name}</h2>
          <BlogSection
            key={selectedOrigin.origin_id}
            type="blog"
            origin_id={selectedOrigin.origin_id}
            destination={selectedOrigin}
            showCreateButtons={false}
          />
        </div>
      )}
    </section>
  )
}

export default WorldMapSection
